import React from "react";
import { Switch, Route } from "react-router-dom";
import NotFound from "./Page/Error/NotFound";
import Home from "./Page/Home/HomeContainer";
import AmbasadorContainer from "./Page/Ambasador/AmbasadorContainer";
import MyChildContainer from "./Page/MyChild/MyChildContainer";
import MyUpdatesContainer from "./Page/MyUpdates/MyUpdatesContainer";
import MyUpdatesContainerV2 from "./Page/MyUpdates/MyUpdatesContainerV2";
import MyDonationContainer from "./Page/MyDonation/MyDonationContainer";
import EmailChildContainer from "./Page/EmailChild/EmailChildContainer";
import VisitChildContainer from "./Page/VisitChild/VisitChildContainer";
import MyUpdatesSingleContainer from "./Page/MyUpdates/MyUpdatesSingleContainer";
import Faq from "./Page/Faq/Faq";
import ContactUsContainer from "./Page/ContactUs/ContactUsContainer";
import ProjectSingle from "./Page/Project/ProjectSingle";
import DocumentViewer from "../v2/components/DocumentViewer/DocumentViewer";
import Main from "./Main";


import WeeklyDevotionContainer  from "./Page/WeeklyDevotion2022/WeeklyDevotionContainer";// 2022

class Dashboard extends React.Component {
    render() {
        return (
            <>
            <Switch>
                <Route
                    path={`${this.props.match.url}/`}
                    exact
                    component={Home}
                />
                <Route
                    path={`${this.props.match.url}/child/:childId`}
                    component={MyChildContainer}
                />
                <Route
                    path={`${this.props.match.url}/my-updates`}
                    exact
                    component={MyUpdatesContainerV2}
                />
                <Route
                    path={`${this.props.match.url}/my-updates/:updateId`}
                    exact
                    component={MyUpdatesSingleContainer}
                />
                <Route
                    path={`${this.props.match.url}/my-updates/year/:year`}
                    exact
                    component={MyUpdatesContainerV2}
                />
                <Route
                    path={`${this.props.match.url}/my-donation`}
                    component={MyDonationContainer}
                />
                <Route
                    path={`${this.props.match.url}/email-child/:childId`}
                    component={EmailChildContainer}
                />
                {/* <Route
                    path={`${this.props.match.url}/visit-my-child/:childId?`}
                    component={VisitChildContainer}
                /> */}
                <Route path={`${this.props.match.url}/faq`} component={Faq} />

                {/* 2022 */}
                <Route
                    path={`${this.props.match.url}/weekly-devotion`}
                    component={WeeklyDevotionContainer}
                />

                <Route
                    path={`${this.props.match.url}/contact-us`}
                    component={ContactUsContainer}
                />
                <Route
                    path={`${this.props.match.url}/project/:projectId`}
                    component={ProjectSingle}
                />
                <Route
                    path={`${this.props.match.url}/letters`}
                    component={Documents}
                />
                
               <Route path={`${this.props.match.url}/ambassador`} 
                      component={AmbasadorContainer} />

                <Route component={NotFound} />
            </Switch>
            </>
        );
    }
}

const Documents = () => {
    return (
        <Main>
            <DocumentViewer />
        </Main>
    );
};

export default Dashboard;
